$(function () {
    let App = window.App;
    App.imageZoomModal = {};

    App.imageZoomModal.open = function (entity, entityId, needImgNumber = 0) {
        $.ajax({
            type: 'GET',
            url: '/ajax/image-zoom',
            dataType: 'json',
            data: {
                entity,
                'entity_id': entityId,
            },
            success: function (response) {
                if (response.status === 'OK') {
                    $('footer').before(response.modal_view);

                    $('#imageZoomMain').slick({
                        dots: false,
                        speed: 500,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        infinite: false,
                        adaptiveHeight: true,
                        waitForAnimate: false
                    }).slick('slickGoTo', needImgNumber).on('afterChange', function (event, slick, currentSlide) {
                        updateActiveSlideInPreview(currentSlide);
                    });

                    updateActiveSlideInPreview(needImgNumber);

                    let $imageZoomModal = $('#imageZoomModal');
                    App.modal.open($imageZoomModal);

                    window.App.lazyImageLoading();
                } else {
                    console.error('Image Zoom Modal: error getting data');
                }
            }
        });
    }

    const updateActiveSlideInPreview = function (needImgNumber) {
        $('#imageZoomPreview img').removeClass('active');
        $(`#imageZoomPreview img:eq(${needImgNumber})`).addClass('active');
    }

    App.imageZoomModal.setActiveSlide = function ($currentImg, needImgNumber) {
        updateActiveSlideInPreview(needImgNumber);
        $('#imageZoomMain').slick('slickGoTo', needImgNumber)
    }
});